'use client';

import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { UserImages } from '../components/UserImages';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Clock } from 'lucide-react';

export function History() {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    if (!user) {
        return null;
    }

    return (
        <div className="min-h-screen bg-background">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {/* Header */}
                <div className="mb-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors mb-4 font-medium"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back
                    </button>
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-primary/10 rounded-lg">
                            <Clock className="h-6 w-6 text-primary" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-foreground">Image History</h1>
                            <p className="text-muted-foreground mt-1">All images you've processed and saved to the cloud</p>
                        </div>
                    </div>
                </div>

                {/* Images Grid */}
                <div className="bg-card border border-border rounded-lg p-8">
                    <UserImages />
                </div>
            </div>
        </div>
    );
}
